import { Navigate } from "react-router-dom";
import SuperAdminLayout from "../layouts/SuperAdminLayout";
import Login from "../pages/auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import CountryAdmin from "../pages/SuperAdmin/Country/CountryAdmin";
import Dashboard from "../pages/CountryAdmin/Dashboard/Dashboard";
import Question from "../pages/CountryAdmin/Question/Question";
import StaticStrings from "../pages/CountryAdmin/StaticStrings/StaticStrings";
import StaticContent from "../pages/CountryAdmin/StaticContent/StaticContent";
import CountryData from "../pages/SuperAdmin/CountryData/CountryData";
import Hcps from "../pages/CountryAdmin/Hcps/Hcps";
import CountryAdminLayout from "../layouts/CountryAdminLayout";
import { strings } from "../strings/strings";
import Hospital from "../pages/CountryAdmin/Hospital/Hospital";
import Request from "../pages/CountryAdmin/Request/Request";

import VeryfyOtp from "../pages/auth/VeryfyOtp";
import Settings from "../pages/SuperAdmin/Settings/Settings";

export const Path = {
  Login: "/login",
  VerifyOtp: "/verify-otp",
  AdminRoot: "/admin",
  SuperRoot: "/superadmin",
};

export const AuthRoutes = [
  {
    path: Path.Login,
    element: <Login />,
  },
  {
    path: Path.VerifyOtp,
    element: <VeryfyOtp />,
  },
];

export const SuperAdminRoutes = {
  path: Path.SuperRoot,
  element: (
    <ProtectedRoute allowedRoles={[strings.super_admin]}>
      <SuperAdminLayout />
    </ProtectedRoute>
  ),
  children: [
    { index: true, element: <Navigate to="country-admin" replace /> },
    { path: "country-admin", element: <CountryAdmin /> },
    { path: "country-data", element: <CountryData /> },
    { path: "settings", element: <Settings /> },
  ],
};

export const AdminRoutes = {
  path: "/country",
  element: (
    <ProtectedRoute allowedRoles={["countryAdmin", "country_admin"]}>
      <CountryAdminLayout />
    </ProtectedRoute>
  ),
  children: [
    { index: true, element: <Navigate to="dashboard" replace /> },
    { path: "dashboard", element: <Dashboard /> },
    { path: "static-strings", element: <StaticStrings /> },
    { path: "static-content", element: <StaticContent /> },
    { path: "questions", element: <Question /> },
    {path: "hospitals", element: <Hospital /> },
    { path: "hcps", element: <Hcps /> },
    { path: "requests", element: <Request /> },
  ],
};
